import script from "./TheSkin.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSkin.vue?vue&type=script&setup=true&lang=js"

import "./TheSkin.vue?vue&type=style&index=0&id=5faa5480&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5faa5480"]])

export default __exports__